import { useNavigate } from 'react-router-dom';
import ListScreen from '../../../components/listScreen/ListScreen';
import { ENTITY_NAME_BACK_OFFICE_FIRM } from '../../../dao/dbConstants';

const Firms = () => {
  const navigate = useNavigate();

  const handleRowClick = (row) => {
    navigate('/bo/firm/' + row.id);
  };

  return (
    <ListScreen
      entityName={ENTITY_NAME_BACK_OFFICE_FIRM}
      heading="Firms"
      showAddButton={false}
      showSearch={true}
      enableRowClick={true}
      onRowClick={handleRowClick}
    />
  );
};

export default Firms;